import { translate } from 'src/app/project/features/translate/translate';

export function transformFlagValue(value: boolean): string {
  return value ? translate('flagged') : translate('unflagged');
}
